export default {
    OPPOSITE_PLATFORM: 'OPPOSITE_PLATFORM',
};
